import { TableHeader } from '@/components/ui/table';

export function SOHHeader() {
  return (
    <TableHeader narrow className="text-left align-bottom">
      SOH
    </TableHeader>
  );
}
